<div class="show_heading">

  <div style="border-bottom: 1px solid #ccc; padding-bottom: 10px;">
    <div class="show_event_heading">Events for {{ data.sent_data[0]?.ScheduledDate | date: 'fullDate' }}</div>

    <div (click)="closeDialog()" class="show_event_cancel">X</div>
  </div>

  <div *ngIf="data.sent_data.length > 0; else noEvents" >
    <div *ngFor="let event of data.sent_data;let i = index " class="event_container row" style="border-bottom: 1px solid #ccc; padding-bottom: 10px;">
      <div class="event_details col-md-6">
        <div class="even_item">
          <div>
            <div class="Events" style="margin-top: 15px;">
              <div class="event_title" [innerHTML]="getsafevalue(event.EventCaption)">{{ event.EventCaption }} </div>
              <div class="event_time">{{ event.ScheduledDate | date: 'fullDate' }}</div>
              <div class="event_half">&#x2022; {{ event.ScheduledDate | date: 'hh:mm:ss a'}}</div>
              <div class="account_name">&#x2022; {{ event.AccountName }}</div>

            </div>
            <div class="event_changes">
              <!-- <mat-form-field appearance="outline" class="event_changes">
                <input matInput placeholder="Specify any required changes" style=" font-family:var(--font);" type="text">
              </mat-form-field> -->
              <mat-accordion >
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    Changes
                  </mat-expansion-panel-header>
                  <div>
                    <mat-form-field appearance="outline" class="event_changes">
                      <input 
                        matInput 
                        placeholder="Specify any required changes" 
                        style="font-family:var(--font);" 
                        type="text">
                    </mat-form-field>
                    <div class="send_button" >SEND</div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
              
            </div>
          </div>

          <div class="show_events_buttons" *ngIf="event.Status === 'Pending'">
            <div class="accept_button" (click)="data.acceptEvent(event)">APPROVE</div>
            <!-- <div class="hold_button" (click)="data.holdEvent(event)">HOLD</div> -->
            <!-- <div class="hold_button" >HOLD</div> -->

            <div class="decline_button" (click)="data.declineEvent(event)">DECLINE</div>
          </div>
          <div class="show_events_buttons" *ngIf="event.Status !== 'Pending'">
            <div class="accept_button">{{event.Status}}</div>
            <!-- <div class="hold_button" (click)="data.holdEvent(event)">HOLD</div> -->
            <!-- <div class="hold_button" >HOLD</div> -->
          </div>
        </div>
      </div>

      <div class="instagram_view col-md-6">
        <div class="instagram_heading">Instagram View</div>
        <div class="event_item">

          <div class="instagram_post">
            <div class="profile_section">
              <img [src]="event.EventMediaLinks" alt="Profile Image" class="profile_image" />
              <div class="profile_name">{{ event.AccountName }}</div>
            </div>

            <div class="post_image" style="text-align: center;">
              <img [src]="event.EventMediaLinks" alt="Post Image" />
            </div>

            <div class="post_icons">
              <div class="icons">
                <mat-icon class="material-symbols-outlined">
                  favorite
                </mat-icon>
                <mat-icon class="material-symbols-outlined">
                  chat_bubble
                </mat-icon>
                <mat-icon class="material-symbols-outlined">
                  send
                </mat-icon>
              </div>
            </div>

            <div class="post_description" >
              <div class="post_description_title" style="display: inline-block; font-size: 20px; font-weight: 500;    margin-left: 9px;
    margin-bottom: 8px;">{{ event.AccountName }}</div> 
              <div class="post_description_caption" style="    display: inline-block; padding-left: 10px; font-size: 18px;" [innerHTML]="getsafevalue(event.EventCaption)">{{ event.EventCaption }}</div>
            </div>

            <div class="add_comment">
              <input type="text" placeholder="Add a comment..." />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #noEvents>
  <div class="Events_close"> No events available.</div>
  </ng-template>
</div>